import { render } from "./ScaleLegend.vue?vue&type=template&id=071e463e&scoped=true"
import script from "./ScaleLegend.vue?vue&type=script&lang=js"
export * from "./ScaleLegend.vue?vue&type=script&lang=js"

import "./ScaleLegend.vue?vue&type=style&index=0&id=071e463e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071e463e"]])

export default __exports__